module.exports = __webpack_public_path__ + "img/jia.6756587c.png";